//活动状态
export const UNAPPROVED = 'UNAPPROVED'; //待审核
export const NOT_START = 'NOT_START'; //未开始
export const UNDER_WAY = 'UNDER_WAY'; //进行中
export const END = 'END'; //已结束

//操作类型
export const APPROVE = 'APPROVE'; //审核
export const DELETE = 'DELETE'; //删除
export const STOP = 'STOP'; //终止
